














import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import ProgressColor from "./progress-color";

@Component({ name: "ui-progress-bar" })
export default class UiProgressBarComponent extends Vue {
  @Prop({ default: "дней", type: String })                    text: string;
  @Prop({ default: 100, type: Number })                        max: number;
  @Prop({ default: 50, type: Number })                       value: number;
  
  getValue(): Number {
    return (this.value * 100) / this.max;
  }
  getText() {
    return this.text;
  }
  onClick(){
    
    this.$emit("click");
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-progress-bar/src/ui-progress-bar.vue